/**
 * PropertiesPage
 * Dedicated page for browsing and filtering properties
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/AppIcon";
import PropertyGrid from "../../components/public/PropertyGrid";
import PublicFooter from "../../components/public/PublicFooter";
import PublicHeader from "../../components/public/PublicHeader";
import QuickFiltersBar from "../../components/public/QuickFiltersBar";
import Button from "../../components/ui/Button";
import type { PropertyFilters } from "../../types";

const PropertiesPage: React.FC = () => {
	const navigate = useNavigate();
	const [activeFilters, setActiveFilters] = useState<PropertyFilters>({});

	// Handle filter changes
	const handleFilterChange = (filters: PropertyFilters) => {
		setActiveFilters(filters);
	};

	return (
		<div className="min-h-screen bg-background">
			{/* Header */}
			<PublicHeader onScrollToProperties={() => {}} />

			{/* Page Header */}
			<div className="bg-card border-b border-border">
				<div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
					<div className="flex items-center justify-between">
						<div>
							<h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
								Available Properties
							</h1>
							<p className="text-muted-foreground">
								Browse properties you can rent or buy right now
							</p>
						</div>
						<Button
							variant="outline"
							onClick={() => navigate("/")}
							className="hidden sm:flex"
						>
							<Icon name="Home" size={16} className="mr-2" />
							Back to Home
						</Button>
					</div>
				</div>
			</div>

			{/* Quick Filters Bar */}
			<QuickFiltersBar onFilterChange={handleFilterChange} />

			{/* Property Grid Section */}
			<PropertyGrid filters={activeFilters} />

			{/* Footer */}
			<PublicFooter />
		</div>
	);
};

export default PropertiesPage;
